export default __webpack_public_path__ + "static/media/img12.c1351607.jpg";